// import { apiSlice } from "../../app/api/apiSlice";

import { apiSlice } from "../../api/apiSlice";

export const HeroModelApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getHeroModel: builder.query({
      query: ({ limit, page, search }) =>
        `/api/v1/admin/hero-model/listing?page=${page}&limit=${limit}&search=${encodeURIComponent(
          search
        )}`,
      providesTags: (result, error) => [{ type: "HeroModel" }],
    }),
    createHeroModel: builder.mutation({
      query: (data) => {
        return {
          url: "/api/v1/admin/hero-model",
          method: "POST",
          body: data,
          // headers: {
          //   "Content-Type": "multipart/form-data",
          // },
        };
      },
      invalidatesTags: ["HeroModel"],
    }),

    getHeroModelById: builder.query({
      query: (id) => `/api/v1/admin/hero-model/${id}`,
      providesTags: (result, error, id) => [{ type: "HeroModel", id }],
    }),

    updateHeroModel: builder.mutation({
      query: ({ id, data }) => {
        return {
          url: `/api/v1/admin/hero-model/${id}`,
          method: "PATCH",
          body: data,
        };
      },
      invalidatesTags: ["HeroModel"],
    }),

    deleteHeroModel: builder.mutation({
      query: (id) => ({
        url: `/api/v1/admin/hero-model/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["HeroModel"],
    }),
  }),
});

export const {
  useGetHeroModelQuery,
  useCreateHeroModelMutation,
  useUpdateHeroModelMutation,
  useGetHeroModelByIdQuery,
  useDeleteHeroModelMutation,
} = HeroModelApiSlice;
